import * as React from 'react';
import { useEffect } from 'react';
import { Button, FormItem, Modal, TextArea } from '@iba-team/portal-react-components/dist';
import { DaysAvailableNamespace } from '../types';
import { useTranslation } from 'react-i18next';
import { InputNumber } from '../../../../utils_components/InputNumber';
import { useSetState } from 'react-use';
import './AllowanceModalStyles.scss';
import { observer } from 'mobx-react';
import { DaysAvailableStore } from '../../../../store/DaysAvailable';

export const TransferredModal = observer((props: DaysAvailableNamespace.TransferredModalCallProps) => {
  const {t} = useTranslation();
  const {updateUserBalance, fetchProfileRemainingDays} = DaysAvailableStore;
  const [data, setData] = useSetState<DaysAvailableNamespace.UpdateTransferredDaysBaseFields>({comment: '', newValue: 0});

  useEffect(() => {
    setData({newValue: props.transferredDays});
  }, [props.transferredDays]);

  const disabledCondition = (data.newValue === undefined) || data.newValue === props.transferredDays || !data.comment.length;
  const onSubmit = () => {
    updateUserBalance({...data,
      employeeId: props.userId,
      valueType: DaysAvailableNamespace.BalanceType.TRANSFER_DAYS,
      isAllowancePermanent: false,
      oldValue: props.transferredDays}).then(() => {
      setTimeout(() => {
        props.onClose();
        fetchProfileRemainingDays({userId: props.userId});
      }, 200);
    });
  };

  const footer = [
    <Button theme={{color: 'grey', variant: 'neutral'}} onClick={props.onClose}>{t('buttons.cancel')}</Button>,
    <Button theme={{color: 'green', variant: 'primary'}} onClick={onSubmit} disabled={disabledCondition}>{t('buttons.save')}</Button>,
  ];
  return (
    <Modal visible={true}
      titleText={t('availableDays.modals.transferred.title')}
      footer={footer}
      onClose={props.onClose}>
      <div className={'allowanceModal-container'}>
        <p className={'allowanceModal-container__description'}>
          {t('availableDays.modals.transferred.description')}
        </p>
        <FormItem label={t('availableDays.modals.transferred.inputLabel')} isRequired>
          <InputNumber
            placeholder={'0'}
            onChange={(val) => {
              setData({newValue: val});
            }}
            value={data.newValue}/>
        </FormItem>
        <FormItem isRequired label={t('availableDays.modals.transferred.reasonLabel')}>
          <TextArea onChange={(e) => setData({comment: e.target.value})} placeholder={t('placeholder.reasonPlaceholder')}/>
          <p className={'allowanceModal-container__reasonText'}>
            {t('availableDays.modals.reasonDescription')}
          </p>
        </FormItem>
      </div>
    </Modal>
  );
});